import React from 'react';
import {
  SummaryLayout,
  Paper,
  SlideablePaper,
  HideOnTablet,
} from 'quanta-ui';
import { Layout, ClientService } from 'quanta-flows/modules/layout';
import InsuranceSummary from './wizard-panel/insuranceSummary';
import InsuranceSummaryMinimized from './wizard-panel/insuranceSummary/minimized';
// import {InsuranceSummaryMinimized,InsuranceSummary,QuoteSummary} from 'quanta-flows/modules/proposal/health';
// import { QuoteSummary } from 'quanta-flows/modules/proposal/health';
import SummaryPanel from './summary-panel';
// import { SummaryPanel } from 'quanta-flows/modules/proposal/health';
import WizardPanel from './wizard-panel';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import QuoteSummary from './summary-panel/quoteSummary';
import { useParams } from 'react-router-dom';

export default function NewPolicyIssuance(props) {
  let nav = ['Quote', 'Buy Policy'];
  const { product_name } = useParams();
  // const product_name = 'Super Top Up'
  const params = useParams();
  //console.log(params);
  const lob_code = params?.lobCode;
  const lob_name = 'Health';
  const product_code = params?.productCode;
  // const product_name= params?.productName;
  const plan_name = params?.plan_name;
 
  const plan_code = params?.plan_code;

  return (
    <Layout
      nav={nav}
      service_type={ClientService}
      title={`Your ${product_name} Proposal`}
    >
      <SummaryLayout
        summary={<SummaryPanel />}
        showFloatingSummary={true}
        summaryIcon={<FontAwesomeIcon icon={faFileAlt} size="2x" />}
      >
        <WizardPanel />
      </SummaryLayout>
      <HideOnTablet className="mt-8">
        {/* <SlideablePaper className="fixed bottom-0" height={24} minimized={<InsuranceSummaryMinimized/>}> */}
        <SlideablePaper
          className="fixed bottom-0"
          height={24}
          minimized={
            <InsuranceSummaryMinimized
              lobCode={lob_code}
              lobName={lob_name}
              // customerID={customerID}
              productName={product_name}
              productCode={product_code}
              planName={plan_name}
              planCode={plan_code}
              // proposalNumber={proposal_number}
            />
          }
        >
          <Paper className="bg-neutral shadow-2xl drop-shadow-2xl">
            <InsuranceSummary
              lobCode={lob_code}
              lobName={lob_name}
              // customerID={customerID}
              productName={product_name}
              productCode={product_code}
              planName={plan_name}
              planCode={plan_code}
              // proposalNumber={proposal_number}
            />
          </Paper>
        </SlideablePaper>
        {/* </SlideablePaper> */}
      </HideOnTablet>
      <QuoteSummary />
    </Layout>
  );
}
